import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { UiService } from 'core/services/ui.service';
import { ListFiltersComponent } from '../list';

@Component({
  selector: 'lms-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit, OnDestroy {
  @Input() options: {
    class: string;
    list: {
      listId: string;
      columnChooser: boolean;
      download: boolean;
      filters: ListFiltersComponent;
      fields: any[]; // valid only for admin tables not for skeletor, delete when not needed
      filterRow: boolean;
      hideItemsSelector: boolean;
      hidePrint: boolean;
      hideSearch: boolean;
      skeletor: boolean; // TODO flag to maintain compatibility true for skeletor table false for admin old ones, delete when not needed
      skipEncoding: boolean;
      customDownload: boolean;
    };
  };
  @Output() clickFilter: EventEmitter<any> = new EventEmitter<any>();
  @Output() clickDownload: EventEmitter<any> = new EventEmitter<any>();

  constructor(public uiService: UiService) {}

  ngOnInit() {}

  ngOnDestroy() {}

  get advancedFiltersEnabled() {
    if (this.options && this.options.list && this.options.list.filters) {
      return this.options.list.filters.filtersQuestions.some((filter) => filter.controlType !== 'hidden');
    }
    return false;
  }

  iconClicked() {
    if (this.advancedFiltersEnabled) {
      this.options.list.filters.toggleVisible();
    }
  }

  onDownload() {
    this.clickDownload.emit();
  }
}
